var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResultFailed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.4286 4.57143L4.57145 11.4286",
  stroke: "currentColor",
  strokeWidth: 2.29,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.57141 4.57143L11.4286 11.4286",
  stroke: "currentColor",
  strokeWidth: 2.29,
  strokeLinecap: "round"
})));
export default SvgResultFailed;